import { useCallback, useMemo, useReducer } from 'react';
import { ActionTypes } from './useStore.types';
export const useStore = () => {
    const [state, dispatch] = useReducer((state, action) => {
        switch (action.type) {
            case ActionTypes.SET_VALUE:
                return { ...state, value: action.payload };
            case ActionTypes.SET_OPTIONS_ARE_OPEN:
                return { ...state, optionsAreOpen: action.payload };
            case ActionTypes.SET_FOCUSED:
                return { ...state, focused: action.payload };
            case ActionTypes.SET_CURRENT_OPTION:
                return { ...state, currentIndex: action.payload };
            default:
                console.error('Invalid action type');
                return state;
        }
    }, { value: '', optionsAreOpen: false, focused: false });
    const setValue = useCallback((value) => dispatch({ type: ActionTypes.SET_VALUE, payload: value }), [dispatch]);
    const setOptionsAreOpen = useCallback((optionsAreOpen) => dispatch({ type: ActionTypes.SET_OPTIONS_ARE_OPEN, payload: optionsAreOpen }), [dispatch]);
    const setFocused = useCallback((focused) => dispatch({ type: ActionTypes.SET_FOCUSED, payload: focused }), [dispatch]);
    const setCurrentIndex = useCallback((currentOption) => dispatch({ type: ActionTypes.SET_CURRENT_OPTION, payload: currentOption }), [dispatch]);
    const store = useMemo(() => ({ ...state, setValue, setOptionsAreOpen, setFocused, setCurrentIndex }), [state, setValue, setOptionsAreOpen, setFocused, setCurrentIndex]);
    return store;
};
